<script>
import Main from './main.vue';

export default Main.extend({
  methods: {
    getData() {
      return new Promise((res) => {
        // Seed data
        const output = [
          {
            name: 'Source language(s)',
            data: [{
              x: 0,
              y: 1,
              data: 2,
            }],
          },
          {
            name: 'Target language(s)',
            data: [{
              x: 1,
              y: 1,
              data: 23,
            }],
          },
          {
            name: 'Language pairs',
            data: [{
              x: 2,
              y: 1,
              data: 34,
            }],
          },
        ];
        res(output);
      });
    },
  },
});
</script>
